module.exports = __webpack_public_path__ + "img/full_cell.2ada7a73.png";